function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMom = function SvgLogoMom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 577 612"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m0-128.776-37.174 64.389L0 0l37.174-64.387 37.175-64.389z",
    style: {
      fill: "#00aeef",
      fillRule: "nonzero"
    },
    transform: "translate(154.892 536.567)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-128.776-37.175 64.387L-74.349 0H0l37.174-64.389z",
    style: {
      fill: "#42c8f5",
      fillRule: "nonzero"
    },
    transform: "translate(421.369 611.574)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7V3.387c-.097.654-.117.731-.481 1.809L-3.387 12.7h-2.175l-2.655-7.37c-.231-.75-.289-.943-.481-2.021V12.7h-2.195V0h2.906L-4.6 9.063c.154.366.193.5.25.981.078-.596.097-.673.231-.981L-.598 0h2.906v12.7z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(141.545 224.898)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.102c-.922.635-2 .924-3.578.924-1.598 0-2.637-.269-3.598-.924-1.309-.904-1.732-1.963-1.732-4.291V-.924h2.405v7.87c0 1.885.981 2.828 3.001 2.828 1.848 0 2.83-1 2.83-2.828v-7.87h2.424v7.735c0 2.328-.424 3.368-1.752 4.291",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(212.574 228.749)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.695C-1.348-7.293-2.444-7.6-3.291-7.6c-1.135 0-1.866.462-1.866 1.174 0 .539.307.866 1.213 1.346C-2.001-4.041-.731-3.232-.135-2.635c.539.538.866 1.385.866 2.27 0 2.271-1.655 3.598-4.464 3.598-.385 0-.77-.039-1.136-.076-.903-.135-1.327-.27-2.655-.885-.174-.078-.461-.213-.828-.385l1.02-2.233c.924.501 1.308.693 1.81.885.635.231 1.327.366 1.828.366 1.115 0 1.846-.5 1.846-1.27 0-.539-.289-.904-1.115-1.366l-1.963-1.116C-7.178-4.137-7.87-4.983-7.87-6.369c0-.635.192-1.289.5-1.77.211-.327.538-.654.942-.943.925-.635 1.713-.846 3.195-.846a8.2 8.2 0 0 1 2.386.327c.616.192.962.327 1.808.73z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(274.714 265.385)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7V0h7.734v2.059h-5.31v3.137h4.349v2.058H2.424v3.387h5.561V12.7z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(298.941 224.898)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.102c-.923.635-2 .924-3.578.924-1.598 0-2.637-.269-3.598-.924-1.309-.904-1.732-1.963-1.732-4.291V-.924h2.404v7.87c0 1.885.982 2.828 3.002 2.828 1.848 0 2.829-1 2.829-2.828v-7.87h2.425v7.735c0 2.328-.424 3.368-1.752 4.291",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(392.63 228.749)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7V3.387c-.097.654-.116.731-.481 1.809L-3.387 12.7h-2.175l-2.655-7.37c-.231-.75-.289-.943-.481-2.021V12.7h-2.195V0h2.907L-4.6 9.063c.154.366.193.5.25.981.078-.596.096-.673.232-.981L-.598 0h2.906v12.7z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(469.302 224.898)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7V3.387c-.097.654-.117.731-.481 1.809L-3.387 12.7h-2.175l-2.655-7.37c-.231-.75-.289-.943-.481-2.021V12.7h-2.195V0h2.906L-4.6 9.063c.154.366.193.5.25.981.078-.596.097-.673.231-.981L-.598 0h2.906v12.7z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(141.545 332.026)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-6.888-1.461 4.6h2.942zm3.137 9.794-1-3.137h-4.254l-1.039 3.137h-2.539l4.598-12.7h2.175l4.599 12.7z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(197.702 372.832)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 12.7-4.233-6.042V12.7h-2.425V0h2.425v5.927L-.25 0h2.791l-4.369 6.177L2.771 12.7z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(271.884 332.026)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.069 280.144h2.424v12.7h-2.424z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1466.25 -835.242)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.815-5.445 4.6a7 7 0 0 1-.27-.502c-.096-.154-.135-.25-.153-.269a2 2 0 0 1-.174-.442V12.7h-2.31V0h2.791L-.23 8.352c.019.038.077.133.134.268s.096.212.116.25l.116.328.114.231V0h2.291v12.815z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(389.574 332.026)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.314c-1.347.328-2.136.424-3.194.424-4.215 0-7.139-2.695-7.139-6.619 0-1.924.731-3.598 2.098-4.85C-6.928.076-5.465-.424-3.271-.424c.923 0 1.847.097 2.655.289C0 .019.385.154 1.271.538l-.579 2.02c-.461-.172-.807-.287-1.039-.365-.905-.307-1.808-.461-2.616-.461-2.849 0-4.83 1.75-4.83 4.271 0 2.598 2.174 4.579 5.002 4.579.578 0 .905-.057 1.655-.268V6.812h2.425v5.194c-.578.135-1 .251-1.289.308",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(473.855 332.91)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.158c-.577 0-.996-.455-.996-1.082S-.577-.005 0-.005c.574 0 .99.454.99 1.081S.574 2.158 0 2.158M0-.924c-1.206 0-2.049.822-2.049 2.002.005 1.179.848 2.004 2.049 2.004 1.185 0 2.044-.843 2.044-2.006 0-1.178-.84-2-2.044-2",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(274.755 301.291)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.056v-.909h-2.529V.909h1.011V-.576h1.245v-.904h-1.245v-.576z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(301.822 310.059)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.315h.489c.383 0 .658.067.844.205.246.181.398.545.398.947C1.731-.413 1.29 0 .489 0H0zm.562-.776H-.892V.776H.557c.689 0 1.198-.187 1.557-.57.339-.362.533-.863.533-1.375 0-.505-.19-.998-.522-1.352-.381-.405-.834-.57-1.563-.57",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(151.148 431.115)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .679h1.273v-.752H0v-.769h1.554v-.752H-.858v3.867h2.485v-.752H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(173.475 424.878)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.362h.387c.479 0 .572.155.572.421 0 .273-.097.454-.572.454H0zm1.625 1.148q.216-.291.216-.744-.001-.56-.326-.86c-.234-.221-.501-.296-1.059-.296H-.858V.752H0V-.735h.237L1.066.714l.022.038h.95L1.097-.871c.259-.079.39-.167.528-.343",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(193.246 431.213)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .679h.387c.277 0 .608.078.608.449a.4.4 0 0 1-.214.367c-.089.047-.173.059-.394.059H0zm.349-.752H0V-.88h.387c.318 0 .501.145.501.397q-.002.409-.539.41m.964.318a.8.8 0 0 0 .281-.216c.145-.171.231-.408.231-.635a1 1 0 0 0-.317-.72c-.216-.198-.472-.268-.979-.268H-.892v3.867H.697c.789 0 1.223-.379 1.223-1.066 0-.471-.228-.82-.607-.962",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(214.326 424.878)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-1.133-.678-1.326-.02-.041h-.948L-.464-.284v1.651h.86V-.282L1.689-2.5H.737z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(237.132 428.654)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.339q.353 0 .932.259L1-2.05l.342-.773-.066-.031a3.6 3.6 0 0 0-.54-.218 2.5 2.5 0 0 0-.72-.098c-.447 0-.693.066-.978.261a1.2 1.2 0 0 0-.295.296 1.07 1.07 0 0 0-.158.559c0 .44.218.706.899 1.095l.575.327c.241.136.288.226.288.335C.347-.117.164 0-.119 0c-.139 0-.334-.04-.507-.102a4 4 0 0 1-.521-.256l-.072-.038-.361.794.067.032.242.113c.386.179.521.223.801.265l.023.003c.102.01.208.02.317.02.865 0 1.381-.422 1.381-1.128 0-.278-.103-.546-.274-.717-.178-.178-.538-.41-1.134-.73-.267-.141-.315-.218-.315-.327 0-.163.186-.268.472-.268",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(269.64 431.19)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.176 268.287h.86v3.866h-.86z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1466.25 -699.625)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.866h-.858V0h2.379v-.752H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(302.436 434.346)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.866h-1.001l-1.052 1.563v-1.563h-.858V0h.858v-1.605L-.949-.032-.927 0h.993l-1.397-1.983z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(331.269 434.346)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1.529-.001.004-1.011-2.702h-.975v3.867h.791V.506l.773 2.142.018.05h.739L1.2.461v2.237h.824v-3.867h-.976z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(360.432 423.106)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.817 268.287h.86v3.866h-.86z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1466.25 -699.625)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.866h-.858V0h2.379v-.752H0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(396.467 434.346)scale(4.16667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.362V-.752h-.858v3.866h2.379v-.752z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(417.89 421.372)scale(4.16667)"
  }));
};
export { SvgLogoMom as ReactComponent };
export default __webpack_public_path__ + "static/logo-mom.ff8da27b.svg";